import { StyleSheet, Text, View } from 'react-native';
import React, { FC, ReactNode, useCallback } from 'react';
import { Modal } from 'react-native';
import { TouchableOpacity } from 'react-native';
import { Button } from '../../../components/Button';
import { STYLE_VARS } from '../../../constants/style-vars';

interface BookingPopupProps {
  children?: ReactNode;
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  isModalVisible: boolean;
  handleConfirm: () => void;
}

const BookingPopup: FC<BookingPopupProps> = ({
  children,
  isModalVisible,
  setIsModalVisible,
  handleConfirm,
}) => {
  return (
    <Modal visible={isModalVisible} animationType="fade" transparent={true}>
      <View style={styles.container}>
        <View style={styles.modalContainer}>
          <View>{children}</View>
          <View style={{ flexDirection: 'row', gap: 10, alignItems: 'center' }}>
            <Button
              text="CANCEL"
              style={[STYLE_VARS.dangerButton, { flex: 1 }]}
              onPress={setIsModalVisible.bind(null, false)}
              className=""
            />
            <Button
              text="CONFIRM"
              style={[STYLE_VARS.blueButton, { flex: 1 }]}
              onPress={handleConfirm}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default BookingPopup;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 40,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  modalContainer: {
    padding: 30,
    borderRadius: 20,
    backgroundColor: 'white', // Màu nền của modal (trong suốt)
  },
});
